
<input #file2 type="file" (change)="onSelects2(file2.files)" [accept]="'.jpg, .png, .gif, .jpeg'"
    [multiple]="'multiple'" class="btn btn-file my-2" />
<br />

<div class="qr-image-view" *ngIf="qrCodeResult2.length > 0 || isShowImage==true">
    <img id="qr-image" alt="" style="max-width: 100%" />
</div>
